// @ts-nocheck
// Using public directory paths instead of direct imports

interface InstructionSet {
  title: string
  section: string
  sectionRaw: Required<string>
  steps: string[]
  note?: string
}

interface ModuleContent {
  [moduleId: string]: {
    content: InstructionSet[]
    articleTitle?: string
    description?: string
    image_main?: string
    image?: string
  }
}

// Define image paths
const publicImagePaths = {
  how_to_set_up_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_MAIN.png",
  how_to_set_up_kompakt_img_1:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_1.png",
  how_to_set_up_kompakt_img_2:
    "/images/sections/kompakt-qs/how_to_set_up_your_kompakt/KOMPAKT_SET_UP_2.png",
  how_to_call_and_message_img_main:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_MAIN.png",
  how_to_call_and_message_img_1:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_1.png",
  how_to_call_and_message_img_2:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_2.png",
  how_to_call_and_message_img_3:
    "/images/sections/kompakt-qs/how_to_call_and_message/CALL_MESSAGE_3.png",
  how_to_stay_organized_img_main:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_MAIN.png",
  how_to_stay_organized_img_1:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_1.png",
  how_to_stay_organized_img_2:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_2.png",
  how_to_stay_organized_img_3:
    "/images/sections/kompakt-qs/how_to_stay_organized/STAY_ORGANIZED_3.png",
  how_to_take_and_view_photos_img_main:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_MAIN.png",
  how_to_take_and_view_photos_img_1:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_1.png",
  how_to_take_and_view_photos_img_2:
    "/images/sections/kompakt-qs/how_to_take_and_view_photos/PHOTOS_2.png",
  how_to_use_offline_plus_img_main:
    "/images/sections/kompakt-qs/how_to_use_offline_plus/OFFLINE_1.png",
  how_to_update_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_update_kompakt/KOMPAKT_UPDATE_1.png",
  how_to_sync_and_backup_kompakt_img_main:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_MAIN.png",
  how_to_sync_and_backup_kompakt_img_1:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_1.png",
  how_to_sync_and_backup_kompakt_img_2:
    "/images/sections/kompakt-qs/how_to_sync_and_backup_with_mudita_center/SYNC_BACKUP_2.png",
  recorder_app_img_main:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_MAIN.png",
  recorder_app_img_1:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_1.png",
  recorder_app_img_2:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_2.png",
  recorder_app_img_3:
    "/images/sections/kompakt-qs/recorder_app/RECORDER_APP_3.png",
  privacy_and_security_img_main:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_MAIN.png",
  privacy_and_security_img_1:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_01.png",
  privacy_and_security_img_2:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_02.png",
  privacy_and_security_img_3:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_03.png",
  privacy_and_security_img_4:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_04.png",
  privacy_and_security_img_5:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_05.png",
  privacy_and_security_img_6:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_06.png",
  privacy_and_security_img_7:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_07.png",
  privacy_and_security_img_8:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_08.png",
  privacy_and_security_img_9:
    "/images/sections/kompakt-qs/privacy_and_security/PRIVACY_SECURITY_09.png",
  basic_settings_and_customization_img_main:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_MAIN.png",
  basic_settings_and_customization_img_1:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_01.png",
  basic_settings_and_customization_img_2:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_02.png",
  basic_settings_and_customization_img_3:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_03.png",
  basic_settings_and_customization_img_4:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_04.png",
  basic_settings_and_customization_img_5:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_05.png",
  basic_settings_and_customization_img_6:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_06.png",
  basic_settings_and_customization_img_7:
    "/images/sections/kompakt-qs/basic_settings_and_customization/BASIC_SETTINGS_07.png",
  connectivity_img_main:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_MAIN.png",
  connectivity_img_1:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_1.png",
  connectivity_img_2:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_2.png",
  connectivity_img_3:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_3.png",
  connectivity_img_4:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_4.png",
  connectivity_img_5:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_5.png",
  connectivity_img_6:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_6.png",
  connectivity_img_7:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_7.png",
  connectivity_img_8:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_8.png",
  connectivity_img_9:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_9.png",
  connectivity_img_10:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_10.png",
  connectivity_img_11:
    "/images/sections/kompakt-qs/connectivity/CONNECTIVITY_11.png",
  troubleshooting_img_main:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_MAIN.png",
  troubleshooting_img_1:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_1.png",
  troubleshooting_img_2:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_2.png",
  troubleshooting_img_3:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_3.png",
  troubleshooting_img_4:
    "/images/sections/kompakt-qs/troubleshooting/TROUBLESHOOTING_4.png",
  alarm_app_img_main: "/images/sections/kompakt-qs/alarm_app/ALARM_APP.png",
  alarm_app_img_1: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_1.png",
  alarm_app_img_2: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_2.png",
  alarm_app_img_3: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_3.png",
  alarm_app_img_4: "/images/sections/kompakt-qs/alarm_app/ALARM_APP_4.png",
  messaging_img_main:
    "/images/sections/kompakt-qs/messaging/MESSAGING_MAIN.png",
  messaging_img_1: "/images/sections/kompakt-qs/messaging/MESSAGING_1.png",
  messaging_img_2: "/images/sections/kompakt-qs/messaging/MESSAGING_2.png",
  messaging_img_3: "/images/sections/kompakt-qs/messaging/MESSAGING_3.png",
  messaging_img_4: "/images/sections/kompakt-qs/messaging/MESSAGING_4.png",
  messaging_img_5: "/images/sections/kompakt-qs/messaging/MESSAGING_5.png",
  camera_app_img_main:
    "/images/sections/kompakt-qs/camera_app/CAMERA_APP_MAIN.png",
  camera_app_img_1: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_1.png",
  camera_app_img_2: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_2.png",
  camera_app_img_3: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_3.png",
  camera_app_img_4: "/images/sections/kompakt-qs/camera_app/CAMERA_APP_4.png",
  notes_img_main: "/images/sections/kompakt-qs/notes_app/NOTES_APP_MAIN.png",
  notes_img_1: "/images/sections/kompakt-qs/notes_app/NOTES_APP_1.png",
  notes_img_2: "/images/sections/kompakt-qs/notes_app/NOTES_APP_2.png",
  maps_app_img_main: "/images/sections/kompakt-qs/maps_app/MAPS_APP_MAIN.png",
  maps_app_img_1: "/images/sections/kompakt-qs/maps_app/MAPS_APP_1.png",
  maps_app_img_2: "/images/sections/kompakt-qs/maps_app/MAPS_APP_2.png",
  weather_app_img_main:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_MAIN.png",
  weather_app_img_1:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_1.png",
  weather_app_img_2:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_2.png",
  weather_app_img_3:
    "/images/sections/kompakt-qs/weather_app/WEATHER_APP_3.png",
  managing_files_img_main:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_MAIN.png",
  managing_files_img_1:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_1.png",
  managing_files_img_2:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_2.png",
  managing_files_img_3:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_3.png",
  managing_files_img_4:
    "/images/sections/kompakt-qs/managing_files/MANAGING_FILES_4.png",
  backup_and_restore_img_main:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_MAIN.png",
  backup_and_restore_img_1:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_1.png",
  backup_and_restore_img_2:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_2.png",
  backup_and_restore_img_3:
    "/images/sections/kompakt-qs/backup_and_restore/BACKUP_RESTORE_3.png",
  updating_kompakt_img_main:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_MAIN.png",
  updating_kompakt_img_1:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_01.png",
  updating_kompakt_img_2:
    "/images/sections/kompakt-qs/updating_kompakt/UPDATING_KOMPAKT_02.png",
  calling_img_main: "/images/sections/kompakt-qs/calling/CALLING_MAIN.png",
  calling_img_1: "/images/sections/kompakt-qs/calling/CALLING_01.png",
  calling_img_2: "/images/sections/kompakt-qs/calling/CALLING_02.png",
  managing_contacts_img_main:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_MAIN.png",
  managing_contacts_img_1:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_01.png",
  managing_contacts_img_2:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_02.png",
  managing_contacts_img_3:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_03.png",
  managing_contacts_img_4:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_04.png",
  managing_contacts_img_5:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_05.png",
  managing_contacts_img_6:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_06.png",
  managing_contacts_img_7:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_07.png",
  managing_contacts_img_8:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_08.png",
  managing_contacts_img_9:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_09.png",
  managing_contacts_img_10:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_10.png",
  managing_contacts_img_11:
    "/images/sections/kompakt-qs/managing_contacts/MANAGING_CONTACTS_11.png",
  calendar_app_img_main:
    "/images/sections/kompakt-qs/calendar_app/CALENDAR_APP_01.png",
}

export const moduleContent: ModuleContent = {
  // How to set up your Kompakt section
  "sim-card": {
    image_main: publicImagePaths.how_to_set_up_kompakt_img_main,
    image: publicImagePaths.how_to_set_up_kompakt_img_1,
    content: [
      {
        title: "To insert a SIM card:",
        section: "How to set up your Kompakt",
        sectionRaw: "How to set up your Kompakt",
        steps: [
          "Insert the <strong>SIM Key</strong> into the round hole",
          "Fully remove the <strong>SIM tray</strong>",
          "Insert a <strong>SIM card</strong> into the SIM tray - gold side of the SIM facing down",
          "Insert the <strong>SIM tray</strong> into Kompakt",
        ],
      },
    ],
  },
  "first-setup": {
    image_main: publicImagePaths.how_to_set_up_kompakt_img_main,
    image: publicImagePaths.how_to_set_up_kompakt_img_2,
    content: [
      {
        title: "How to set up Kompakt for the first time:",
        section: "How to set up your Kompakt",
        sectionRaw: "How to set up your Kompakt",
        steps: [
          "Press the <strong>Power Button</strong>",
          "Tap <strong>Language setup</strong>",
          "Select the Language you want",
          "Select the Wi-Fi network you want to join",
          "Enter the Wi-Fi password",
          "Tap <strong>Next</strong>",
          "Read the End User Licence Agreement <strong>Tap Accept</strong>",
          "Enter a new 6 digit passcode",
          "Tap <strong>Confirm passcode</strong>",
          "Enter the 6 digit passcode again",
          "Tap <strong>Set passcode</strong>",
          "Tap <strong>Next</strong>",
          "Rest your finger on the fingerprint scanner",
          "On the vibration, Lift your finger",
          "Continue to Rest and lift finger, slightly changing it's position on the power button each time",
          "Tap <strong>Done</strong>",
          "Tap <strong>Quick Tutorial*</strong> > Tap <strong>Next</strong> to view each page",
          "Tap <strong>Next</strong>",
          "If an update is available, tap <strong>Update</strong>",
          "Tap <strong>Restart phone</strong>",
        ],
        note: "*Skipping the tutorial will not impact the setup in any way",
      },
    ],
  },

  // How to Call and Message section
  "adding-contacts": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_1,
    articleTitle: "How to add contacts to Kompakt",
    description: `There are 3 main ways to add contacts. You can add them individually on Kompakt or you can import all your contacts from your Google or Outlook accounts. You can import your Apple contacts but you must <b>create a Vcard file</b> first.`,
    content: [
      {
        title: "To add single contact on Kompakt:",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Tap the <strong>Phone</strong> icon",
          "Tap <strong>Contacts</strong>",
          "Tap the <strong>Add contact</strong> icon",
          "Enter the contact information",
          "Tap <strong>Create</strong>",
        ],
      },
      {
        title: "To import your contacts from Google or Outlook:",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Click <strong>Import contacts</strong>",
          "Select which account you would like to import from",
          "Log in to your selected account",
          "Select the individual contacts to import or select <strong>All contacts</strong>",
          "Click <strong>Import selected contacts</strong> to transfer contacts to phone*",
        ],
        note: "*Important - do not disconnect your phone while the import is in progress",
      },
      {
        title: "To import contacts from CSV file or vCard:",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Click <strong>Import contacts</strong>",
          "Click <strong>Upload CSV or vCard</strong>",
          "Select the CSV or Vcard file from your computer",
          "Select the individual contacts to import or select <strong>All contacts</strong>",
          "Click <strong>Import selected contacts</strong> to transfer contacts to phone*",
        ],
        note: "*Important - do not disconnect your phone while the import is in progress",
      },
    ],
  },
  "making-calls": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_2,
    articleTitle: "How to make a call on Kompakt",
    content: [
      {
        title: "To call a contact:",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Select the contact you want to call",
          "Tap <strong>Call</strong>",
        ],
      },
      {
        title: "To call a new number:",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Dial</strong>",
          "Enter the number you want to call",
          "Tap the <strong>Call</strong> icon",
        ],
      },
    ],
  },
  "sending-messages": {
    image_main: publicImagePaths.how_to_call_and_message_img_main,
    image: publicImagePaths.how_to_call_and_message_img_3,
    articleTitle: "How to send SMS and MMS Messages",
    description: `You can send easily send messages to contacts or to <b>new numbers</b>`,
    content: [
      {
        title: "To send a Message to a contact",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Select the contact you want to message",
          "Enter your message*",
          "Tap the <strong>Send</strong> icon",
        ],
        note: "*If the keyboard does not appear, tap the blinking cursor",
      },
      {
        title: "To send a MMS Message to a contact",
        section: "How to call and message",
        sectionRaw: "How to call and message",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Select the contact you want to message",
          "Tap the <strong>Image</strong> icon",
          "Select the image you want to send",
          "Tap <strong>Send</strong>",
        ],
      },
    ],
  },

  // How to Stay Organized section
  notes: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_1,
    content: [
      {
        title: "To create notes:",
        section: "How to Stay Organized",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Notes</strong>",
          "Tap the <strong>Plus</strong> icon*",
          "Write a title for your note (max. 54 characters)",
          "Tap <strong>Enter</strong> on the keyboard",
          "Write more detail for your note",
          "Tap <strong>Done</strong>",
        ],
        note: "*If it is your first note, tap Create new note",
      },
      {
        title: "To delete notes:",
        section: "How to Stay Organized",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Notes</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Select the note(s) to delete by tapping the <strong>Check box(s)</strong>",
          "Tap <strong>Delete</strong>",
          "Tap <strong>Delete</strong>",
        ],
      },
    ],
  },
  calendar: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_2,
    content: [
      {
        title: "How to create a calendar event:",
        section: "How to Stay Organized",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Tap <strong>Apps</strong>*",
          "Tap <strong>Calendar</strong>",
          "Tap the <strong>Left</strong> and <strong>Right arrows</strong> to select the event month",
          "Tap the <strong>Day</strong> you want your event on",
          "Tap the <strong>Plus</strong> icon",
          "Tap <strong>Add Title</strong> to customize the even name",
          "Tap the <strong>Up</strong> and <strong>Down arrows</strong> to select the start time",
          "Tap the <strong>Up</strong> and <strong>Down arrows</strong> to select the end time",
          "Tap <strong>Create</strong>",
        ],
        note: "*You can also tap <strong>todays date</strong> on the home screen to go directly to the calendar",
      },
    ],
  },
  alarms: {
    image_main: publicImagePaths.how_to_stay_organized_img_main,
    image: publicImagePaths.how_to_stay_organized_img_3,
    content: [
      {
        title: "To create your first alarm:",
        section: "How to Stay Organized",
        sectionRaw: "How to Stay Organized",

        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Alarm</strong>",
          "Tap <strong>Create an alarm</strong>",
          "You can select if to repeat the alarm, change the name and sound*",
          "Tap <strong>Create</strong>",
        ],
        note: "*currently snooze is fixed to 5 minute intervals",
      },
      {
        title: "To add additional alarms:",
        section: "How to Stay Organized",
        sectionRaw: "How to Stay Organized",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Alarm</strong>",
          "Tap the <strong>Plus</strong> icon",
          "You can select if to repeat the alarm, change the name and sound*",
          "Tap <strong>Create</strong>",
        ],
        note: "*currently snooze is fixed to 5 minute intervals",
      },
    ],
  },

  // How to take and view photos section
  "view-photos": {
    image_main: publicImagePaths.how_to_take_and_view_photos_img_main,
    image: publicImagePaths.how_to_take_and_view_photos_img_1,
    description: `You can only view photos on kompakt in greyscale but when you use <b>Mudita Center to transfer your photos</b> to a computer you can view them in full colour.`,
    content: [
      {
        title: "How to view photos:",
        section: "How to take and view photos",
        sectionRaw: "How to take and view photos",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Camera</strong>",
          "Tap the <strong>Image</strong> icon",
          "Tap the photo you want to view",
        ],
        note: "You can only view photos on kompakt in greyscale but when you use Mudita Center to transfer your photos to a computer you can view them in full colour.",
      },
    ],
  },
  "take-photos": {
    image_main: publicImagePaths.how_to_take_and_view_photos_img_main,
    image: publicImagePaths.how_to_take_and_view_photos_img_2,
    content: [
      {
        title: "How to take a photo:",
        section: "How to take and view photos",
        sectionRaw: "How to take and view photos",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Camera</strong>",
          "Aim the camera at the object",
          "Tap the <strong>Photo</strong> button*",
        ],
        note: "*As Kompakt has an e-ink display, you may need to hold the phone still for a little longer than a typical smart phone",
      },
    ],
  },

  // How to use Offline+ section
  "using-offline-plus": {
    image_main: publicImagePaths.how_to_use_offline_plus_img_main,
    image: publicImagePaths.how_to_use_offline_plus_img_main,
    content: [
      {
        title: "How to use Offline+",
        section: "How to use Offline+",
        sectionRaw: "How to use Offline+",
        steps: [
          "Slide the <strong>Offline+</strong> switch* to the down position",
        ],
        note: "*The Offline+ switch is located on the upper left side of Kompakt",
      },
      {
        title: "To enable the full phone function:",
        section: "How to use Offline+",
        sectionRaw: "How to use Offline+",
        sectionRaw: "How to use Offline+",
        steps: [
          "Slide the <strong>Offline+</strong> switch* to the up position",
        ],
        note: "*The Offline+ switch is located on the upper left side of Kompakt",
      },
    ],
  },

  // How to update Kompakt section
  "system-update": {
    image_main: publicImagePaths.how_to_update_kompakt_img_main,
    image: publicImagePaths.how_to_update_kompakt_img_main,
    articleTitle: "How to update MuditaOS K on Kompakt",
    description: `When an update is available for Kompakt, you will see a notification at the top of the control panel screen. Please note, you can only update Kompakt on the device itself and not using Mudita Center and Kompakt must be connected to the internet.`,
    content: [
      {
        title: "How to update MuditaOS K on Kompakt",
        section: "How to update Kompakt",
        sectionRaw: "How to update Kompakt",
        steps: [
          "Tap <strong>New MuditaOS K update is available</strong>",
          "Tap <strong>Update</strong>",
          "If needed: read, Tap the <strong>Check box</strong> and tap <strong>Agree</strong> to the licence agreement",
          "The update will download and configure automatically",
          "Tap <strong>Restart phone</strong>",
        ],
      },
    ],
  },

  // How to Sync and Backup with Mudita Center section
  "backup-restore": {
    image_main: publicImagePaths.how_to_sync_and_backup_kompakt_img_main,
    image: publicImagePaths.how_to_sync_and_backup_kompakt_img_1,
    content: [
      {
        title: "How to create a backup for Kompakt:",
        section: "How to Sync and Backup with Mudita Center",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Overview</strong>",
          "Click <strong>Create Backup</strong>",
          "Click <strong>Create Backup</strong> to confirm",
          "Create a password to protect your backup data*",
          "Click <strong>Confirm Passcode</strong>",
          "Enter your passcode to create the backup",
        ],
        note: "*Warning! You can not change the password after you confirm it. If you don't want a password, click <strong>Skip Password</strong> to create the backup",
      },
      {
        title: "How to restore Kompakt from a backup:",
        section: "How to Sync and Backup with Mudita Center",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Overview</strong>",
          "Click <strong>Restore From Backup</strong>",
          "Select the Backup you want to restore from the list",
          "Click <strong>Restore From Backup</strong>",
          "Enter the password protecting the backup*",
          "Click <strong>Confirm</strong>",
        ],
        note: "*Warning! There is no way to recover or change the password for backups. If no password was created, you will skip this step and start the restore process",
      },
    ],
  },
  "file-transfer": {
    image_main: publicImagePaths.how_to_sync_and_backup_kompakt_img_main,
    image: publicImagePaths.how_to_sync_and_backup_kompakt_img_2,
    content: [
      {
        title: "How to add photos to Kompakt:",
        section: "How to Sync and Backup with Mudita Center",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>Photos</strong>",
          "Click <strong>Add File</strong>",
          "Browse and select your image files* to add",
          "Confirm to transfer photos to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
      {
        title: "How to add music files to Kompakt:",
        section: "How to Sync and Backup with Mudita Center",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>Music</strong>",
          "Click <strong>Add File</strong>",
          "Browse and select your audio files* to add",
          "Confirm to transfer music to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
      {
        title: "How to add E-books to Kompakt:",
        section: "How to Sync and Backup with Mudita Center",
        sectionRaw: "How to Sync and Backup with Mudita Center",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>E-books</strong>",
          "Click <strong>Add File</strong>",
          "Browse and select your image files* to add",
          "Confirm to transfer ebooks to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
    ],
  },

  // Recorder app
  "recording-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_1,
    articleTitle: "How to record a voice recording",
    content: [
      {
        title: "How to record a voice recording",
        section: "Recorder app",
        sectionRaw: "Recorder app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Recorder</strong>",
          "Tap the <strong>Record</strong> button to start recording",
          "Tap the <strong>Pause</strong> button to pause recording",
          "Tap <strong>Done</strong> to stop recording",
          "Tap <strong>New recording</strong> to add a title",
          "Tap <strong>Done</strong>",
        ],
      },
    ],
  },

  "listening-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_2,
    articleTitle: "How to listen to a voice recording",
    content: [
      {
        title: "How to listen to a voice recording",
        section: "Recorder app",
        sectionRaw: "Recorder app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Recorder</strong>",
          "Tap the <strong>Menu</strong> icon",
          "Select the recording you want to listen to",
          "Tap the <strong>Play</strong> button",
          "Tap <strong>Done</strong> to close",
        ],
      },
    ],
  },

  "delete-voice-recording": {
    image_main: publicImagePaths.recorder_app_img_main,
    image: publicImagePaths.recorder_app_img_3,
    articleTitle: "How to delete voice recordings",
    description: `You can either delete individual recordings or many at the same time.`,
    content: [
      {
        title: "To delete a single voice recording:",
        section: "Recorder app",
        sectionRaw: "Recorder app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Recorder</strong>",
          "Tap the <strong>Menu</strong> icon",
          "Select the recording you want to delete",
          "Tap the <strong>Bin</strong> icon",
          "Tap <strong>Delete</strong>",
        ],
      },
      {
        title: "To delete many voice recordings:",
        section: "Recorder app",
        sectionRaw: "Recorder app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Recorder</strong>",
          "Tap the <strong>Menu</strong> icon",
          "Tap the <strong>Pencil</strong> icon",
          "Tap the <strong>Check boxes</strong> to select the recordings you want to delete",
          "Tap <strong>Delete</strong>",
          "Tap <strong>Delete</strong>",
        ],
      },
    ],
  },

  // Privacy and Security section
  "add-fingerprints": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_1,
    articleTitle: "How to add fingerprints",
    description: `Kompakt's power button contains a fingerprint scanner, letting you unlock you phone quickly without the passcode.`,
    content: [
      {
        title: "To add a new fingerprint:",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Security</strong>",
          "Tap <strong>Manage Fingerprints</strong>",
          "Type your passcode and tap <strong>Enter</strong> on the keypad",
          "Tap the <strong>Plus</strong> icon",
          "Follow the onscreen instructions*",
        ],
        note: "*Make sure you place a slightly different part of your finger on the sensor after each vibration",
      },
    ],
  },

  "delete-fingerprints": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_2,
    articleTitle: "How to delete fingerprints",
    content: [
      {
        title: "How to delete fingerprints",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Security</strong>",
          "Tap <strong>Manage Fingerprints</strong>",
          "Type your passcode and tap <strong>Enter</strong> on the keypad",
          "Tap the <strong>Bin</strong> icon next to the fingerprint you want to delete",
          "Tap <strong>Delete</strong>",
        ],
      },
    ],
  },

  "manage-location-sharing": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_3,
    articleTitle: "How to manage location sharing",
    description: `Kompakt allows you to either turn all location sharing off or on, or manage location sharing for individual apps.`,
    content: [
      {
        title: "To turn all location sharing off or on:",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Location Sharing</strong>",
          "Tap the <strong>Toggle switch</strong> to turn location sharing for all apps off or on",
        ],
      },
      {
        title: "To manage location sharing for individual apps:",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Location Sharing</strong>",
          "Select the app you want to manage",
          "Select the level of sharing you want",
        ],
      },
    ],
  },

  "block-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_4,
    articleTitle: "How to block numbers",
    description: `Kompakt gives you many ways to block numbers`,
    content: [
      {
        title: "How to block numbers",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "You can choose to block all hidden or all unrecognized numbers",
          "You can block individual numbers when you add a number to your blocked list",
          "You can block a number during an incoming call",
        ],
      },
    ],
  },

  "block-hidden-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_5,
    articleTitle: "How to block hidden or unrecognized numbers",
    description: `You can block all incoming calls and messages from hidden numbers. You can also choose to block all numbers that you don't recognize, you will only receive calls and messages from numbers in your contacts list.`,
    content: [
      {
        title: "To block all hidden or unrecognised numbers:",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Recents</strong>",
          "Tap <strong>App settings</strong> icon in the topbar",
          "Tap <strong>Call Blocking</strong>",
          "Use the <strong>Toggle switches</strong> to select either Block hidden numbers or Block unrecognised numbers",
        ],
      },
    ],
  },

  "add-to-blocked-list": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_6,
    articleTitle: "How to manually add a number to your blocked list",
    content: [
      {
        title: "How to manually add a number to your blocked list",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Recents</strong>",
          "Tap <strong>App settings</strong> icon in the topbar",
          "Tap <strong>Call Blocking</strong>",
          "Tap <strong>Blocked Numbers</strong>",
          "Tap <strong>Add to blocked</strong> or the <strong>Plus</strong> icon",
          "Enter the number you want to block",
          "Tap <strong>Block</strong>",
        ],
      },
    ],
  },

  "block-from-incoming-call": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_7,
    articleTitle: "How to block a number from an incoming call",
    content: [
      {
        title: "How to block a number from an incoming call",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "When you receive a call from the number you want to block:",
          "Tap the <strong>Block</strong> icon",
          "Tap <strong>Block number</strong>",
        ],
      },
    ],
  },

  "unblock-numbers": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_8,
    articleTitle: "How to unblock numbers on Kompakt",
    content: [
      {
        title: "How to unblock numbers on Kompakt",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Tap the <strong>App settings</strong> icon",
          "Tap <strong>Call Blocking</strong>",
          "Tap <strong>Blocked Numbers</strong>",
          "Tap the <strong>Minus</strong> icon for the number you want to unblock",
        ],
      },
    ],
  },

  "stop-showing-files-usb": {
    image_main: publicImagePaths.privacy_and_security_img_main,
    image: publicImagePaths.privacy_and_security_img_9,
    articleTitle: "How to stop Kompakt showing files when connecting via USB-C",
    description: `You can stop Kompakt from showing or accessing files when connected to a computer. This may be useful if you connect to a computer that isn't yours.`,
    content: [
      {
        title: "To stop showing files:",
        section: "Privacy and Security",
        sectionRaw: "Privacy and Security",
        steps: [
          "Connect Kompakt to a computer with a USB-C cable",
          "Press the <strong>Control Center</strong> button",
          "Tap the <strong>Settings</strong> icon",
          "Tap <strong>Connected Devices</strong>",
          "Tap <strong>USB Preferences</strong>*",
          "Tap <strong>No data transfer</strong>",
        ],
        note: "*If Kompakt isn't connected to the computer, you won't see this option!",
      },
    ],
  },

  // Basic settings and customization section
  "change-volume-level": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_1,
    articleTitle: "How to change the volume level",
    description: `There are 2 ways to change the main volume level on Kompakt but you can also change the levels for certain functions like the alarm or ringtone too.`,
    content: [
      {
        title: "To set the main volume though the Control Center:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Swipe the <strong>sound volume bar</strong> below the <strong>Bell</strong> icon up or down",
        ],
      },
      {
        title: "To set the main volume using the volume buttons:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press or hold down the <strong>volume up button</strong> to raise volume",
          "Press or hold down the <strong>volume down button</strong> to lower volume",
        ],
      },
      {
        title: "To change the volume for certain functions:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Sound</strong>",
          "Use the sliders to set the level you want",
        ],
      },
    ],
  },

  "turn-sounds-on-off": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_2,
    articleTitle: "How to turn certain sounds on or off",
    content: [
      {
        title: "How to turn certain sounds on or off",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Sound</strong>",
          "Tap <strong>Advance</strong>",
          "Use the toggle to turn on or off sounds for:",
          "a. Dial pad presses",
          "b. Screen locking",
          "c. Charging (includes vibration)",
          "d. Touch sounds (button presses etc.)",
        ],
      },
    ],
  },

  "change-keyboard-layout": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_3,
    articleTitle: "How to change the Keyboard Layout",
    description: ``,
    content: [
      {
        title: "How to change the Keyboard Layout",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>System</strong>",
          "Tap <strong>Language and Keyboard</strong>",
          "Tap <strong>Keyboard Settings</strong>",
          "Tap <strong>Languages and Styles</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Tap <strong>Layout</strong>",
          "Select the Layout you want to add",
          "Tap the <strong>Back arrow</strong> icon",
          "Tap <strong>Add</strong>",
        ],
        note: "This feature has a complex user interface and may be difficult to navigate.",
      },
    ],
  },

  "change-system-language": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_4,
    articleTitle: "How to change the system language",
    content: [
      {
        title: "How to change the system language",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>System</strong>",
          "Tap <strong>Language and Keyboard</strong>",
          "Tap <strong>System Language</strong>",
          "Select the language you want to use",
          "Tap <strong>Confirm</strong>",
        ],
      },
    ],
  },

  "hide-unhide-app-icons": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_5,
    articleTitle: "How to unhide or hide app icons",
    description: `Some app icons like weather, calendar and alarm are hidden by default, but you can unhide them if you prefer.`,
    content: [
      {
        title: "To unhide or hide apps:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>App layout</strong>",
          "Use the <strong>Toggle switches</strong> to unhide or hide the apps*",
          "Tap the <strong>Back arrow</strong> icon to save the changes and exit",
        ],
        note: "*To see how your app screen will look, tap <strong>Preview</strong>",
      },
    ],
  },

  "change-screen-timeout": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_6,
    articleTitle: "How to change the screen time out delay",
    description: `To save power and to keep your phone secure, Kompakt's screen will sleep after set time delay.`,
    content: [
      {
        title: "To change the screen timeout delay:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Display</strong>",
          "Tap <strong>Screen Timeout</strong>",
          "Select the time delay you want",
        ],
      },
    ],
  },

  "silent-mode": {
    image_main: publicImagePaths.basic_settings_and_customization_img_main,
    image: publicImagePaths.basic_settings_and_customization_img_7,
    articleTitle: "How to put Kompakt in silent mode",
    description: `There are 2 main ways to put Kompakt into silent mode.`,
    content: [
      {
        title: "To set silent mode using the control panel:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap the <strong>Bell</strong> icon or swipe the sound volume bar all the way down",
        ],
      },
      {
        title: "To set silent mode using the volume button:",
        section: "Basic settings and customization",
        sectionRaw: "Basic settings and customization",
        steps: [
          "Hold down the <strong>volume down button</strong> until the sound volume bar is all the way down",
        ],
      },
    ],
  },

  // Connectivity section
  "airplane-mode": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_1,
    articleTitle: "How to turn Airplane mode on or off",
    description: `Airplane mode disables the antenna and Wi-Fi, but still allows you to turn on Bluetooth.`,
    content: [
      {
        title: "To turn airplane mode on or off:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Airplane</strong> icon",
        ],
      },
    ],
  },

  "connect-wifi": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_2,
    articleTitle: "How to connect to Wi-Fi",
    content: [
      {
        title: "How to connect to Wi-Fi",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>Wi-Fi</strong>",
          "Select the Wi-Fi network you want to join",
          "Enter the Wi-Fi network password",
          "Tap <strong>Connect</strong>",
        ],
      },
    ],
  },

  "connect-bluetooth": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_3,
    articleTitle: "How to connect devices using Bluetooth",
    description: `Before starting, ensure the device you want to connect too has Bluetooth turned on and is discoverable.`,
    content: [
      {
        title: "To connect a device:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Connected Devices</strong>",
          "Tap <strong>Pair new device</strong>",
          'If you see a notification "Bluetooth is on", tap x to dismiss it',
          "Select the device you want to pair with from the list",
          "Tap <strong>Pair</strong>",
        ],
        note: "Step 5 will be removed once the bug is fixed.",
      },
      {
        title:
          "You can also turn Bluetooth on and off from the Control Center:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Bluetooth</strong> icon",
        ],
      },
    ],
  },

  "create-hotspot": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_4,
    articleTitle: "How to create a hotspot",
    description: `Hotspots allow other devices to use Kompakt's Wi-Fi or data when they are tethered.`,
    content: [
      {
        title: "To create a hotspot:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>Hotspot and Tethering</strong>",
          "Tap <strong>Wi-Fi Hotspot</strong>",
          "You can edit the name, password* and security settings for the hotspot",
          "To turn on the hotspot Tap the <strong>Toggle Switch</strong> near the top of the screen",
        ],
        note: "*The password must be 8 or more characters long",
      },
      {
        title:
          "You can also turn the hotspot on and off from the Control Center:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Hotspot icon</strong> which is above the Airplane icon",
        ],
      },
    ],
  },

  "share-wifi-password": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_5,
    articleTitle: "How to share Wi-Fi password",
    content: [
      {
        title: "How to share Wi-Fi password",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>Wi-Fi</strong>",
          "Select the Wi-Fi network you are connected to",
          "Tap <strong>Share</strong>",
          "Touch the <strong>power button</strong> to scan your fingerprint or tap <strong>USE PIN</strong> > Enter PIN",
          "Either scan the <strong>QR code</strong> with the other device, or copy the Wi-Fi passcode manually",
        ],
      },
    ],
  },

  "add-esim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_6,
    articleTitle: "How to add an eSIM",
    description: `Before you start, make sure Kompakt is connected to the internet and make sure you are in eSIM mode.`,
    content: [
      {
        title: "How to add an eSIM",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>SIM Cards</strong>",
          "Tap <strong>Add eSIM</strong>",
          "Tap <strong>Continue</strong>",
          "Either scan the <strong>QR code</strong> or tap <strong>Insert code</strong> instead and enter the activation code manually",
          "Read the Profile Policy rules and Tap <strong>Accept</strong> if you agree to the rules",
          "Tap <strong>Add this eSIM</strong>*",
        ],
        note: "*Tap the Check box if you want to enable the eSIM immediately (Kompakt will restart)",
      },
    ],
  },

  "switch-sim-esim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_7,
    articleTitle: "How to switch between SIM 2 and eSIM mode",
    description: `Learn how to install an eSIM.`,
    content: [
      {
        title: "How to switch between SIM 2 and eSIM mode",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>SIM Cards</strong>",
          "Tap <strong>Switch mode</strong>",
          "Tap <strong>Switch mode</strong> and Kompakt will restart automatically",
        ],
      },
    ],
  },

  "data-downloads": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_8,
    articleTitle: "How to allow or stop downloads using data",
    description: `If you stop Kompakt from using mobile data, downloads will need a Wi-Fi connection.
  This is useful if you have a limited data allowance or high cost for data.`,
    content: [
      {
        title: "How to allow or stop downloads using data",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>Mobile Network</strong>",
          "Tap the Mobile data <strong>Toggle switch</strong> to stop or allow Kompakt using mobile data",
        ],
      },
    ],
  },

  "allow-stop-roaming": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_9,
    articleTitle: "How to allow or stop roaming",
    description: `Roaming is when you use your device outside of your home country.
  Your network provider can charge you extra for this feature.
  Always check with your network provider before allowing roaming!`,
    content: [
      {
        title: "To allow roaming:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Network and Internet</strong>",
          "Tap <strong>Mobile Network</strong>",
          "Tap the Roaming <strong>Toggle switch</strong> to stop or allow roaming",
        ],
      },
    ],
  },

  "use-offline-plus": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_10,
    articleTitle: "How to use Offline+",
    description: `Offline+ is more than Airplane mode as it disables the antenna, microphones, camera, Wi-Fi and Bluetooth.`,
    content: [
      {
        title: "To use offline+:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Slide the <strong>Offline+ switch</strong>* to the down position",
        ],
        note: "*The <strong>Offline+ switch</strong> is located on the left side of Kompakt",
      },
      {
        title: "To enable the full phone function:",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Slide the <strong>Offline+ switch</strong> to the up position",
        ],
      },
    ],
  },

  "insert-physical-sim": {
    image_main: publicImagePaths.connectivity_img_main,
    image: publicImagePaths.connectivity_img_11,
    articleTitle: "How to insert a physical SIM card",
    content: [
      {
        title: "How to insert a physical SIM card",
        section: "Connectivity",
        sectionRaw: "Connectivity",
        steps: [
          "Insert the <strong>SIM Key</strong> into the round hole",
          "Fully remove the <strong>SIM tray</strong>",
          "Insert a <strong>SIM card</strong> into the <strong>SIM tray</strong> - gold side of the SIM facing down",
          "Insert the <strong>SIM tray</strong> into Kompakt",
        ],
      },
    ],
  },

  // Troubleshooting section
  "find-phone-number": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_1,
    articleTitle: "How to find your phone number",
    description: `You can find the phone numbers for each of your installed SIM cards in the SIM status screen.`,
    content: [
      {
        title: "To find your phone number:",
        section: "Troubleshooting",
        sectionRaw: "Troubleshooting",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>About</strong>",
          "Tap <strong>SIM status (sim slot #)</strong> for the SIM you want to view",
        ],
      },
    ],
  },

  "factory-reset": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_2,
    articleTitle: "How to do a factory reset on Kompakt",
    description: `Warning! This will delete everything on your phone! Your MuditaOS K version will stay the same.`,
    content: [
      {
        title: "To do a factory reset:",
        section: "Troubleshooting",
        sectionRaw: "Troubleshooting",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>System</strong>",
          "Tap <strong>Factory Reset</strong>",
          "Tap <strong>Factory Reset</strong>",
          "If you are sure you want to delete all your data, tap <strong>Factory Reset</strong>",
          "Kompakt will restart and be ready to set up",
        ],
      },
    ],
  },

  "os-update-fails": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_3,
    articleTitle: "An OS (Operating System) update fails on Kompakt",
    description: `There are a few things you can try if an update fails, a factory reset should be the last resort!`,
    content: [
      {
        title: "An OS (Operating System) update fails on Kompakt",
        section: "Troubleshooting",
        sectionRaw: "Troubleshooting",
        steps: [
          "Manually check for an update and try again",
          "Check you have a stable internet connection",
          "If you don't have Wi-Fi, check that you allow downloads using data",
          "Restart the the device",
          "Do a factory reset",
          "If none of the above fix the problem, contact customer support",
        ],
      },
    ],
  },

  "files-not-showing-usb": {
    image_main: publicImagePaths.troubleshooting_img_main,
    image: publicImagePaths.troubleshooting_img_4,
    articleTitle: "Files don't show when connecting Kompakt via USB-C",
    description: `If you connect Kompakt to your computer but can't see your files, you'll need to allow file transfer.`,
    content: [
      {
        title: "To allow file transfer:",
        section: "Troubleshooting",
        sectionRaw: "Troubleshooting",
        steps: [
          "Connect Kompakt to a computer with a USB-C cable",
          "Press the <strong>Control Center</strong> button",
          "Tap the <strong>Settings</strong> icon",
          "Tap <strong>Connected Devices</strong>",
          "Tap <strong>USB Preferences</strong>*",
          "Tap <strong>File Transfer</strong>",
        ],
        note: "*If Kompakt isn't connected to the computer, you won't see this option!",
      },
    ],
  },

  // Alarm app section
  "create-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_1,
    articleTitle: "How to create an alarm",
    content: [
      {
        title: "To create your first alarm:",
        section: "Alarm app",
        sectionRaw: "Alarm app",
        steps: [
          "Tap <strong>the clock</strong> on the home screen*",
          "Tap <strong>Create an Alarm</strong>",
          "You can edit name and sound and the days it repeats",
          "Tap <strong>Create</strong>",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Alarm</strong>",
      },
      {
        title: "To add additional alarms:",
        section: "Alarm app",
        sectionRaw: "Alarm app",
        steps: [
          "Tap <strong>the clock</strong> on the home screen*",
          "Tap the <strong>Plus</strong> icon",
          "You can edit name and sound and the days it repeats",
          "Tap <strong>Create</strong>",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Alarm</strong>",
      },
    ],
  },

  "edit-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_2,
    articleTitle: "How to edit an alarm",
    content: [
      {
        title: "How to edit an alarm",
        section: "Alarm app",
        sectionRaw: "Alarm app",
        steps: [
          "Tap <strong>the clock</strong> on the home screen*",
          "Tap on the time Alarm you want to edit",
          "Edit the time using the <strong>up</strong> and <strong>down arrows</strong> or using the keypad",
          "You can edit name and sound and the days it repeats",
          "Tap <strong>Save</strong>",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Alarm</strong>",
      },
    ],
  },

  "delete-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_3,
    articleTitle: "How to delete an alarm",
    content: [
      {
        title: "How to delete an alarm",
        section: "Alarm app",
        sectionRaw: "Alarm app",
        steps: [
          "Tap <strong>the clock</strong> on the home screen*",
          "Tap the <strong>Pencil</strong> icon",
          "Tap the <strong>Delete</strong> icon",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Alarm</strong>",
      },
    ],
  },

  "snooze-alarm": {
    image_main: publicImagePaths.alarm_app_img_main,
    image: publicImagePaths.alarm_app_img_4,
    articleTitle: "How to snooze an alarm",
    description: `Snooze is fixed to a 5 minute interval and is not automatic.`,
    content: [
      {
        title: "To snooze the alarm:",
        section: "Alarm app",
        sectionRaw: "Alarm app",
        steps: ["Wait until your alarm rings", "Tap <strong>Snooze</strong>"],
      },
    ],
  },

  // Messaging section
  "send-sms-to-contact": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_1,
    articleTitle: "How to send SMS Messages to a contact",
    description: `You can also send SMS messages to a new number.`,
    content: [
      {
        title: "To send SMS Messages to a contact:",
        section: "Messaging",
        sectionRaw: "Messaging",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Pencil</strong> icon",
          "Select the contact you want to message",
          "Enter your message*",
          "Tap the <strong>Send</strong> icon",
        ],
        note: "*If the keyboard does not appear, tap the blinking cursor",
      },
    ],
  },

  "send-sms-to-new-number": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_2,
    articleTitle: "How to send SMS Messages to a new number",
    description: `You can also send SMS messages to a contact.`,
    content: [
      {
        title: "To send SMS Messages to a new number:",
        section: "Messaging",
        sectionRaw: "Messaging",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Enter the phone number",
          "Tap <strong>send to: xxxxxxxxxxx</strong>",
          "Enter your message*",
          "Tap the <strong>Send</strong> icon",
        ],
        note: "*If the keyboard does not appear, tap the blinking cursor",
      },
    ],
  },

  "send-mms-to-contact": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_3,
    articleTitle: "How to send MMS Messages to a contact",
    description: `You can also send MMS messages to a new number.`,
    content: [
      {
        title: "To send MMS Messages to a contact:",
        section: "Messaging",
        sectionRaw: "Messaging",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Select the contact you want to message",
          "Tap the <strong>Image</strong> icon",
          "Select the image you want to send",
          "Tap <strong>Send</strong>",
        ],
      },
    ],
  },

  "send-mms-to-new-number": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_4,
    articleTitle: "How to send MMS Messages to a new number",
    description: `You can also send MMS messages to a contact.`,
    content: [
      {
        title: "To send MMS Messages to a new number:",
        section: "Messaging",
        sectionRaw: "Messaging",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Plus</strong> icon",
          "Enter the phone number",
          "Tap <strong>send to: xxxxxxxxxxx</strong>",
          "Tap the <strong>Image</strong> icon",
          "Select the image you want to send",
          "Tap <strong>Send</strong>",
        ],
      },
    ],
  },

  "delete-conversations": {
    image_main: publicImagePaths.messaging_img_main,
    image: publicImagePaths.messaging_img_5,
    articleTitle: "How to delete conversations",
    content: [
      {
        title: "How to delete conversations",
        section: "Messaging",
        sectionRaw: "Messaging",
        steps: [
          "Tap <strong>SMS</strong>",
          "Tap the <strong>Pencil</strong> icon",
          "Select the conversations you want to delete",
          "Tap <strong>Delete</strong>",
          "Tap <strong>Delete</strong>",
        ],
      },
    ],
  },

  // Camera app section
  "take-photos-camera": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_1,
    articleTitle: "How to take a photo",
    content: [
      {
        title: "How to take a photo",
        section: "Camera app",
        sectionRaw: "Camera app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Camera</strong>",
          "Aim the camera at the object",
          "Tap the <strong>photo</strong> button*",
        ],
        note: "*As Kompakt has an e-ink display, you may need to hold the phone still for a little longer than a typical smart phone",
      },
    ],
  },

  "view-photos-camera": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_2,
    articleTitle: "How to view photos",
    description: `You can only view photos on Kompakt in greyscale but when you use Mudita Center to transfer your photos to a computer you can view them in full color.`,
    content: [
      {
        title: "How to view photos",
        section: "Camera app",
        sectionRaw: "Camera app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Camera</strong>",
          "Tap the <strong>Image</strong> icon",
          "Tap <strong>the photo</strong> you want to view",
        ],
      },
    ],
  },

  "take-screenshot": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_3,
    articleTitle: "How to take a screenshot",
    content: [
      {
        title: "How to take a screenshot",
        section: "Camera app",
        sectionRaw: "Camera app",
        steps: [
          "Press <strong>Power</strong> button and <strong>Volume down</strong> buttons at the same time*",
        ],
        note: "*Currently there is no feedback that the screenshot was taken, but it will be there when you view your photos",
      },
    ],
  },

  "transfer-photos": {
    image_main: publicImagePaths.camera_app_img_main,
    image: publicImagePaths.camera_app_img_4,
    articleTitle: "How to transfer photos to your computer",
    description: `You can currently transfer photos using Windows File Manager or by sending MMS messages.`,
    content: [
      {
        title: "To transfer photos using Windows:",
        section: "Camera app",
        sectionRaw: "Camera app",
        steps: [
          "Connect Kompakt to a computer with a USB-C cable*",
          "Access Kompakt's files",
          "Open the DCIM folder**",
          "Select the photos you want to transfer and copy them to your computer",
        ],
        note: "*If files don't show when connecting Kompakt you need to allow file transfer\n**For screenshots open the Pictures folder",
      },
    ],
  },

  // Notes app section
  "create-notes": {
    image_main: publicImagePaths.notes_img_main,
    image: publicImagePaths.notes_img_1,
    articleTitle: "How to create notes",
    content: [
      {
        title: "How to create notes",
        section: "Notes app",
        sectionRaw: "Notes app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Notes</strong>",
          "Tap the <strong>Plus</strong> icon*",
          "Write a title for your note (max. 54 characters)",
          "Tap <strong>Enter</strong> on the keyboard",
          "Write more detail for your note",
          "Tap <strong>Done</strong>",
        ],
        note: "*If it is your first note, tap <strong>Create new note</strong>",
      },
    ],
  },

  "delete-notes": {
    image_main: publicImagePaths.notes_img_main,
    image: publicImagePaths.notes_img_2,
    articleTitle: "How to delete notes",
    content: [
      {
        title: "How to delete notes",
        section: "Notes app",
        sectionRaw: "Notes app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Notes</strong>",
          "Tap the <strong>Edit</strong> icon",
          "Tap the <strong>Check box</strong> to select the note(s) you want to delete",
          "Tap <strong>Delete</strong>",
          "Tap <strong>Delete</strong>",
        ],
      },
    ],
  },

  // Maps app section
  "download-map": {
    image_main: publicImagePaths.maps_app_img_main,
    image: publicImagePaths.maps_app_img_1,
    articleTitle: "How to download a map",
    description: `To view a region or country on the maps app, you will need to download the map.
  This requires an internet connection. Once you have downloaded the map, you won't need the internet to search or view the map.`,
    content: [
      {
        title: "To download a map:",
        section: "Maps app",
        sectionRaw: "Maps app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Maps</strong> > Tap <strong>Continue</strong>*",
          "Tap the <strong>Menu</strong> icon",
          "Tap <strong>Manage Maps</strong>",
          "Tap the <strong>Search</strong> icon**",
          "Enter the country or region name of the map you want",
          "Tap the <strong>Download</strong> icon",
        ],
        note: "*Only when using maps for the first time\n**Or tap <strong>All Maps</strong> and select the region you want",
      },
    ],
  },

  "delete-map": {
    image_main: publicImagePaths.maps_app_img_main,
    image: publicImagePaths.maps_app_img_2,
    articleTitle: "How to delete a map",
    content: [
      {
        title: "How to delete a map",
        section: "Maps app",
        sectionRaw: "Maps app",
        steps: [
          "Tap <strong>Apps</strong>",
          "Tap <strong>Maps</strong>",
          "Tap the <strong>Menu</strong> icon",
          "Tap <strong>Manage Maps</strong>",
          "Tap the <strong>Edit</strong> icon",
          "Tap the <strong>Delete</strong> icon for the map you want to delete",
          "Tap <strong>Delete Map</strong>",
        ],
      },
    ],
  },

  // Weather app section
  "open-weather-app": {
    image_main: publicImagePaths.weather_app_img_main,
    image: publicImagePaths.weather_app_img_1,
    articleTitle: "How to open the weather app",
    content: [
      {
        title: "How to open the weather app",
        section: "Weather app",
        sectionRaw: "Weather app",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Weather</strong> widget",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Weather</strong>",
      },
    ],
  },

  "change-weather-default-location": {
    image_main: publicImagePaths.weather_app_img_main,
    image: publicImagePaths.weather_app_img_2,
    articleTitle: "How to change the weather default location",
    content: [
      {
        title: "How to change the weather default location",
        section: "Weather app",
        sectionRaw: "Weather app",
        steps: [
          "Press the <strong>Control Center</strong> button*",
          "Tap <strong>Weather</strong> widget",
          "Tap the <strong>Menu</strong> icon",
          "Tap the <strong>Pencil</strong> icon",
          "Select the current default location",
          "Either search for the location you want or tap <strong>Use your current location</strong>**",
          "Tap <strong>Done</strong>",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Weather</strong>\n** You may need to manage location sharing in settings",
      },
    ],
  },

  // Managing files section
  "transfer-photos-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_1,
    articleTitle: "How to transfer photos to Kompakt",
    content: [
      {
        title: "How to transfer photos to Kompakt",
        section: "Managing files",
        sectionRaw: "Managing files",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>Photos</strong>",
          "Click <strong>Add file</strong>",
          "Browse and select your image files* to upload",
          "Confirm to transfer photos to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
    ],
  },

  "transfer-music-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_2,
    articleTitle: "How to transfer music to Kompakt",
    content: [
      {
        title: "How to transfer music to Kompakt",
        section: "Managing files",
        sectionRaw: "Managing files",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>Music</strong>",
          "Click <strong>Add file</strong>",
          "Browse and select your audio files* to upload",
          "Confirm to transfer music to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
    ],
  },

  "transfer-ebooks-to-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_3,
    articleTitle: "How to transfer E-books to Kompakt",
    content: [
      {
        title: "How to transfer E-books to Kompakt",
        section: "Managing files",
        sectionRaw: "Managing files",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage Files</strong>",
          "Click <strong>E-books</strong>",
          "Click <strong>Add file</strong>",
          "Browse and select your image files* to upload",
          "Confirm to transfer ebooks to Kompakt",
        ],
        note: "*If a file type is not supported by Kompakt, you won't be able to select it",
      },
    ],
  },

  "delete-files-from-kompakt": {
    image_main: publicImagePaths.managing_files_img_main,
    image: publicImagePaths.managing_files_img_4,
    articleTitle: "How to delete files from Kompakt",
    content: [
      {
        title: "How to delete files from Kompakt",
        section: "Managing files",
        sectionRaw: "Managing files",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Manage</strong> (Music, Photos or E-book)",
          "Go to the files you want to delete",
          "Select the files using the <strong>Checkbox</strong>*",
          "Click <strong>Delete</strong>",
          "Click <strong>Delete file</strong>",
        ],
        note: "*To select all, click the <strong>minus icon checkbox</strong> near the top of the screen",
      },
    ],
  },

  // Backup and restore section
  "create-backup": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_1,
    articleTitle: "How to create a backup for Kompakt",
    content: [
      {
        title: "How to create a backup for Kompakt",
        section: "Backup and restore",
        sectionRaw: "Backup and restore",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Overview</strong>",
          "Click <strong>Create backup</strong>",
          "Click <strong>Create backup</strong> to confirm",
          "Create a password to protect your backup data*",
          "Click <strong>Confirm Passcode</strong>",
          "Enter your passcode to create the backup",
        ],
        note: "*Warning! You can not change the password after you confirm it.\nIf you don't want a password, click <strong>Skip password</strong> to create the backup",
      },
    ],
  },

  "restore-from-backup": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_2,
    articleTitle: "How to restore Kompakt from a backup",
    content: [
      {
        title: "How to restore Kompakt from a backup",
        section: "Backup and restore",
        sectionRaw: "Backup and restore",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Overview</strong>",
          "Click <strong>Restore from backup</strong>",
          "Select the Backup you want to restore from the list",
          "Click <strong>Restore from backup</strong>",
          "Enter the password protecting the backup*",
          "Click <strong>Confirm</strong>",
        ],
        note: "*Warning! There is no way to recover or change the password for backups.\nIf no password was created, you will skip this step and start the restore process",
      },
    ],
  },

  "find-backup-file": {
    image_main: publicImagePaths.backup_and_restore_img_main,
    image: publicImagePaths.backup_and_restore_img_3,
    articleTitle: "How to find the backup file to restore Kompakt",
    content: [
      {
        title: "How to find the backup file to restore Kompakt",
        section: "Backup and restore",
        sectionRaw: "Backup and restore",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Mudita Center</strong> > Click <strong>Settings</strong>*",
          "You will see the file path (Example: C:/User/Documents/Mudita/Kompakt/backup)",
          "Follow the file path using your computer's browser",
        ],
        note: "*The backup tab opens by default, if it does not, click <strong>Backup</strong> at the top of the screen",
      },
    ],
  },

  // Updating Kompakt section
  "manually-check-updates": {
    image_main: publicImagePaths.updating_kompakt_img_main,
    image: publicImagePaths.updating_kompakt_img_1,
    articleTitle: "How to manually check for MuditaOS K updates on Kompakt",
    content: [
      {
        title: "How to manually check for MuditaOS K updates on Kompakt",
        section: "Updating Kompakt",
        sectionRaw: "Updating Kompakt",
        steps: [
          "Make sure Kompakt is connected to the internet",
          "Touch the <strong>Control panel button</strong>",
          "Tap the <strong>Settings</strong> icon",
          "Tap <strong>About</strong>",
          "Tap <strong>Software Update</strong>",
          "If an update is available, you can update MuditaOS K",
        ],
      },
    ],
  },

  "update-kompakt": {
    image_main: publicImagePaths.updating_kompakt_img_main,
    image: publicImagePaths.updating_kompakt_img_2,
    articleTitle: "How to update MuditaOS K on Kompakt",
    description: `When an update is available for Kompakt, you will see a notification at the top of the control panel screen. You can also manually check for updates.`,
    content: [
      {
        title: "How to update MuditaOS K on Kompakt",
        section: "Updating Kompakt",
        sectionRaw: "Updating Kompakt",
        steps: [
          "Make sure Kompakt is connected to the internet",
          "Tap <strong>New MuditaOS K update is available</strong>",
          "Tap <strong>Update</strong>",
          "If needed: read, Tap the <strong>Check box</strong> and tap <strong>Agree</strong> to the licence agreement",
          "The update will download and configure automatically",
          "Tap <strong>Restart phone</strong>",
        ],
      },
    ],
  },

  // Calling section
  "make-call": {
    image_main: publicImagePaths.calling_img_main,
    image: publicImagePaths.calling_img_1,
    articleTitle: "How to make a call on Kompakt",
    content: [
      {
        title: "To call a contact:",
        section: "Calling",
        sectionRaw: "Calling",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Select the contact you want to call",
          "Tap <strong>Call</strong>",
        ],
      },
      {
        title: "To call a new number:",
        section: "Calling",
        sectionRaw: "Calling",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Dial</strong>",
          "Enter the number you want to call",
          "Tap the <strong>Call</strong> icon",
        ],
      },
    ],
  },

  "change-emergency-number": {
    image_main: publicImagePaths.calling_img_main,
    image: publicImagePaths.calling_img_2,
    articleTitle: "How to change the emergency call number",
    description: `<strong>Warning! Your emergency call may not be answered</strong> if you change the default number! The default emergency number is for the emergency services in your state or country.`,
    content: [
      {
        title: "To change the emergency number:",
        section: "Calling",
        sectionRaw: "Calling",
        steps: [
          "Press the <strong>Control Center</strong> button",
          "Tap <strong>Settings</strong> icon",
          "Tap <strong>Safety and Emergency</strong>",
          "Tap <strong>Emergency Call</strong>",
          "Tap <strong>Call in case of Emergency</strong>",
          "Tap the <strong>existing number</strong>",
          "Enter the new number",
          "Tap <strong>Save</strong>",
        ],
        note: "The default emergency number is for the emergency services in your state or country.",
      },
    ],
  },

  // Calendar app section
  "create-calendar-event": {
    articleTitle: "How to create a calendar event",
    image_main: publicImagePaths.calendar_app_img_main,
    image: publicImagePaths.calendar_app_img_main,
    content: [
      {
        title: "How to create a calendar event",
        section: "Calendar app",
        sectionRaw: "Calendar app",
        steps: [
          "Tap <strong>today's date</strong> on the home screen*",
          "Tap the <strong>left</strong> and <strong>right arrows</strong> to select the month",
          "Tap <strong>the Day</strong> you want your event on",
          "Tap the <strong>Plus</strong> icon",
          "Tap <strong>Add Title</strong> to customize the even name",
          "Tap the <strong>up</strong> and <strong>down arrows</strong> to select the start time",
          "Tap the <strong>up</strong> and <strong>down arrows</strong> to select the end time",
          "Tap <strong>Create</strong>",
        ],
        note: "*You can also unhide the app icon to enable access by tapping <strong>Apps</strong> > <strong>Calendar</strong>",
      },
    ],
  },

  // Managing contacts section
  "unblock-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_1,
    articleTitle: "How to unblock contacts on Kompakt",
    content: [
      {
        title: "How to unblock contacts on Kompakt",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Select the contact you want to block",
          "Tap the <strong>Pencil</strong> icon",
          "Tap the <strong>Unblock contact</strong>",
          "Tap <strong>Unblock contact</strong>",
        ],
      },
    ],
  },

  "block-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_2,
    articleTitle: "How to block contacts on Kompakt",
    content: [
      {
        title: "How to block contacts on Kompakt",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Select the contact you want to block",
          "Tap the <strong>Pencil</strong> icon",
          "Tap the <strong>Block contact</strong>",
          "Tap <strong>Block contact</strong>",
        ],
      },
    ],
  },

  "add-contacts-manually": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_3,
    articleTitle: "How to manually add contacts on Kompakt",
    content: [
      {
        title: "How to manually add contacts on Kompakt",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Tap the <strong>Add contact</strong> icon",
          "Enter the contact information",
          "Tap <strong>Create</strong>",
        ],
      },
    ],
  },

  "delete-contacts": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_4,
    articleTitle: "How to delete contacts on Kompakt",
    content: [
      {
        title: "How to delete contacts on Kompakt",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Tap <strong>Phone</strong>",
          "Tap <strong>Contacts</strong>",
          "Select the contact you want to delete",
          "Tap the <strong>Pencil</strong> icon",
          "Tap the <strong>Bin</strong> icon",
          "Tap <strong>Delete contact</strong>",
        ],
      },
    ],
  },

  "import-contacts-outlook": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_5,
    articleTitle: "How to import contacts from Outlook",
    content: [
      {
        title: "How to import contacts from Outlook",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Click <strong>Import contacts</strong>",
          "Click <strong>Outlook</strong>",
          "Log in to <strong>Outlook</strong>",
          "Select the individual contacts to import or select <strong>All contacts</strong>",
          "Click <strong>Import selected contacts</strong> to transfer contacts to phone*",
        ],
        note: "*Important - do not disconnect your phone while the import is in progress",
      },
    ],
  },

  "import-contacts-google": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_6,
    articleTitle: "How to import contacts from Google",
    content: [
      {
        title: "How to import contacts from Google",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Click <strong>Import contacts</strong>",
          "Click <strong>Google</strong>",
          "Log in to Google",
          "Select the individual contacts to import or select <strong>All contacts</strong>",
          "Click <strong>Import selected contacts</strong> to transfer contacts to phone*",
        ],
        note: "*Important - do not disconnect your phone while the import is in progress",
      },
    ],
  },

  "import-contacts-csv-vcard": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_7,
    articleTitle: "How to import contacts from CSV file or vCard",
    description:
      "Before you start, you need to create a CSV using outlook, create a vCard using Google Account or create a vCard (VCF file) using iCloud.",
    content: [
      {
        title: "How to import contacts from CSV file or vCard",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Click <strong>Import contacts</strong>",
          "Click <strong>Upload CSV or vCard</strong>",
          "Select the CSV or Vcard file from your computer",
          "Select the individual contacts to import or select <strong>All contacts</strong>",
          "Click <strong>Import selected contacts</strong> to transfer contacts to phone*",
        ],
        note: "*Important - do not disconnect your phone while the import is in progress",
      },
    ],
  },

  "create-vcard-icloud": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_8,
    articleTitle: "How to create a vCard (VCF file) using iCloud",
    content: [
      {
        title: "How to create a vCard (VCF file) using iCloud",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "On your computer, sign into your iCloud account using your Apple ID",
          "Click <strong>Contacts</strong>",
          "Select the contacts to export either by using <strong>ctrl + click</strong> or <strong>shift + click</strong>*",
          "Click the <strong>Export</strong> Icon",
          "Click <strong>Export vCard</strong>",
          "The vCard (VCF file) should appear in your downloads folder",
        ],
        note: "*To quickly select all contacts, click the 3 dots in a circle icon > click Select All",
      },
    ],
  },

  "create-csv-vcard-google": {
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_9,
    articleTitle: "How to create a CSV or vCard using Google Account",
    content: [
      {
        title: "How to create a CSV or vCard using Google Account",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "On your computer, sign into your Gmail account using your Google ID",
          "Click the <strong>Grid</strong> icon to show the apps list",
          "Click <strong>Contacts</strong>",
          "Select the contacts to export",
          "Click the <strong>3 dots</strong> icon",
          "Click <strong>Export</strong>",
          "Select how you would like to export the contacts, either CSV or vCard",
          "Click <strong>Export</strong>",
          "The CVS or vCard should appear in your downloads folder",
        ],
        note: "*To quickly select all contacts, click the <strong>down arrow</strong> icon > click <strong>All</strong>",
      },
    ],
  },

  "create-csv-outlook": {
    articleTitle: "How to create a CSV file using Outlook",
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_10,
    content: [
      {
        title: "How to create a CSV file using Outlook",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "On your computer, sign into your Outlook account using your Microsoft ID",
          "Click the <strong>People</strong> icon",
          "Click <strong>Manage contacts</strong>",
          "Click <strong>Export</strong>",
          "Click <strong>Export</strong>",
          "The CVS should appear in your downloads folder",
        ],
      },
    ],
  },

  "delete-contacts-mudita-center": {
    articleTitle: "How to delete contacts using Mudita Center",
    image_main: publicImagePaths.managing_contacts_img_main,
    image: publicImagePaths.managing_contacts_img_11,
    content: [
      {
        title: "How to delete contacts using Mudita Center",
        section: "Managing contacts",
        sectionRaw: "Managing contacts",
        steps: [
          "Open Mudita Center and connect your device",
          "Look under <strong>Your Kompakt</strong> > Click <strong>Contacts</strong>",
          "Hover the mouse pointer over contact you want to delete",
          "Click the <strong>Checkbox</strong> to select the contact*",
          "Select any other contacts you want to delete",
          "Click <strong>Delete</strong>",
          "Click <strong>Delete</strong>",
        ],
        note: "*To select all, click the <strong>minus</strong> icon near the top of the screen",
      },
    ],
  },
}
